import { useInfiniteQuery } from '@tanstack/react-query';

import { FileGateway } from '../gateways';
import { handleResponse } from '@/core/utils/response';
import { fileKeyFactory } from '@/core/query-keys';
import type { RawFile } from '@/core/types';

interface QueryProps {
  pageParam?: number;
}

interface PagedArchivedFilesPage {
  entities: RawFile[];
  nextPage: number | null;
  previousPage: number | null;
}

async function fetchPagedArchivedFiles({ pageParam }: QueryProps): Promise<PagedArchivedFilesPage> {
  const { files, nextPage, previousPage } = await handleResponse(
    FileGateway.fetchArchived({ pageParam })
  );
  return { entities: files, nextPage, previousPage };
}

export function useFetchArchivedFiles({ options = {} } = {}) {
  return useInfiniteQuery<PagedArchivedFilesPage, Error>(
    fileKeyFactory.archived(),
    ({ pageParam = 1 }) => fetchPagedArchivedFiles({ pageParam }),
    {
      getNextPageParam: (lastPage) => lastPage.nextPage,
      ...options
    }
  );
}
